module.exports = __webpack_public_path__ + "media/images/front/recorte_1-73fd5cb31f0f6f8f0a5a3523aea9d717.png";